
import { gql } from '@apollo/client';

export const CREATE_PARENT_RELATIONSHIP = gql`
    mutation CreateParentRelationship($newParentIdentifier: String!, $childUserId: Int!) {
        createParentRelationship(newParentIdentifier: $newParentIdentifier, childUserId: $childUserId) {
            status
        }
    }
`;
